import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import 'url-search-params-polyfill'
// import pack from '!!json-loader!src/../package.json?limit=1'

// URL PARAMS
let urlParams = new window.URLSearchParams(window.location.search)

// DEBUG
let debug = process.env.NODE_ENV !== 'production'
// debug = false
if (urlParams.get('_debug') !== null) debug = true
if (urlParams.get('_debug') === 'false') debug = false

// VCONSOLE
let vconsole = process.env.NODE_ENV !== 'production'
vconsole = false
if (urlParams.get('_vconsole') !== null) vconsole = true
if (urlParams.get('_vconsole') === 'false') vconsole = false

let auth = true;
if (urlParams.get('auth') === null || urlParams.get('auth') === undefined) auth = true
if (urlParams.get('auth') === 'false') auth = false


// STATE
const state = {


  // version: pack.version,
  debug: debug,
  vconsole: vconsole,

  // LOADING
  loading: {
    progress: 0,
    step: null,
    completed: false,
  },

  // ROUTE
  route: {
    afterLoad: 'home', // default page to show after loading
    curr: {
      parent: null,
      child: null,
    },
    prev: {
      parent: null,
      child: null,
    },
  },

  // BLEND
  blend: {
    percent: 0,
  },

  firebase: {
    ui: null,
    user_data: null,
    logged_in: false 
  },

  auth: auth,

  y :0,

  // web rtc - prompted in WebAudioService
  consented: false
}


// EXPORT
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
